import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const SpinningLogo = styled.img`
  width: ${(props) => props.width || '48px'};
  height: ${(props) => props.height || '48px'};
  animation: ${spin} 1s linear infinite;
`

const CliparaSpinner = ({ width, height }) => {
  return <SpinningLogo src="/logoNoText.svg" alt="Loading..." width={width} height={height} />
}

export default CliparaSpinner
